// extracted by mini-css-extract-plugin
export default {"closeButton":"Modal_closeButton__AIe5-","container":"Modal_container__qwbgM"};